import * as React from 'react';
import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return <input data-slot="input" type={type} className={cn('h-8 w-full min-w-0 rounded-2xl border border-border/80 bg-card px-3 py-1 text-sm shadow-[0_1px_2px_rgba(15,23,42,0.04)] outline-none transition-[color,box-shadow] placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/30 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20', className)} {...props} />;
}

export { Input };
